<template>
  <img
    @click="onClick"
    :width="width"
    :height="height"
    :src="imageSrc"
    @error="handleError"
  />
</template>

<script>
import { requestUrl } from "@utils/request_url";
export default {
  props: {
    width: {
      type: String,
    },
    height: {
      type: String,
    },
    src: {
      type: String || Object,
    },
    fallback: {
      type: String,
    },
  },
  watch: {
    src(value, oldValue) {
      if (value) {
        this.imageSrc = requestUrl + value;
      }
    },
  },
  data() {
    return {
      imageSrc: requestUrl + this.src,
    };
  },
  methods: {
    handleError() {
      console.log("handleError");
      this.imageSrc = requestUrl + this.fallback;
    },
    onClick() {
      this.$emit("click");
    },
  },
};
</script>
